import * as t from './actionTypes';

const initialState = { isLoading: false, articles: [], settings: {} };

const mooseReducer = (state = initialState, action) => {
  switch (action.type) {

    // set busy
    case t.SET_BUSY:
      return Object.assign({}, state, { isLoading: true });

    // unset busy
    case t.UNSET_BUSY:
      return Object.assign({}, state, { isLoading: false });

    // articles load success
    case t.ARTICLES_LOAD_SUCCESS:
      let articles = action.articles;
      var articleArr = [];
      const keys = Object.keys(articles);
      for (var k = 0; k < keys.length; ++k) {
        articleArr.push(articles[keys[k]]);
      }
      state = Object.assign({}, state, { articles: articleArr });
      return state;

    // articles create success
    case t.ARTICLES_CREATE_SUCCESS:
      let article = action.article;
      articles = state.articles;
      if (!articles) articles = [];
      articles.push(article);
      state = Object.assign({}, state, { articles: articles });
      return state;

    // articles edit success
    case t.ARTICLES_EDIT_SUCCESS:
      var newArticle = action.article;
      let curArticles = state.articles;
      for (let i = 0; i < curArticles.length; i ++) {
        if (curArticles[i].id === action.id) {
          curArticles[i] = newArticle;
          break;
        }
      }
      state = Object.assign({}, state, { articles: curArticles });
      return state;

    // articles delete success
    case t.ARTICLES_DELETE_SUCCESS:
      curArticles = state.articles;
      for (let i = 0; i < curArticles.length; i ++) {
        if (curArticles[i].id === action.id) {
          curArticles.splice(i, 1);
          break;
        }
      }
      state = Object.assign({}, state, { articles: curArticles });
      return state;

    // settings load success
    case t.SETTINGS_LOAD_SUCCESS:
      return {...state, settings: action.settings};

    default:
      return state;
  }
};

export default mooseReducer;
